export function getRandomInt(min, max) {
    return Math.floor(Math.random() * ((max - min) + 1)) + min;
}

export function featureToggle(name, values = [true, false]) {
    if (!name || !window.sessionStorage) return null;
    if (window.sessionStorage.getItem(name) === null) {
        const featureValue = values[getRandomInt(0, values.length - 1)];
        window.sessionStorage.setItem(name, JSON.stringify(featureValue));
        return featureValue;
    }

    return JSON.parse(window.sessionStorage.getItem(name));
}



// WEBPACK FOOTER //
// ./src/services/FeatureToggle.js